export class FrameCoalescer<T> {
  private pending: { value: T } | null = null;
  private frame: { win: Window; id: number } | null = null;

  constructor(private readonly send: (value: T) => void) {}

  schedule(value: T, win: Window = window): void {
    this.pending = { value };
    if (this.frame) return;
    const id = win.requestAnimationFrame(() => {
      this.frame = null;
      const next = this.pending;
      this.pending = null;
      if (next) this.send(next.value);
    });
    this.frame = { win, id };
  }

  flush(value?: T): void {
    const held = this.pending;
    this.cancel();
    if (value !== undefined) this.send(value);
    else if (held) this.send(held.value);
  }

  cancel(): void {
    if (this.frame) this.frame.win.cancelAnimationFrame(this.frame.id);
    this.frame = null;
    this.pending = null;
  }
}
